import React from 'react'
import { styled } from '@mui/material/styles'
import Link from 'next/link'
import { Typography } from '@mui/material'

const PREFIX = 'Tag'

const classes = {
  text: `${PREFIX}-text`,
  link: `${PREFIX}-link`,
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.text}`]: {
    marginRight: theme.spacing(1),
  },

  [`& .${classes.link}`]: {
    color: 'blue',
    fontSize: '12px',
    marginRight: theme.spacing(1),
    textDecoration: 'none',

    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
}))

type Data = {
  id: string
  title: string | null
  name: string | null
}

type Props = {
  data: Data
  type: 'category' | 'tag'
  textType: boolean
}

export const Tag = (props: Props) => (
  <Root>
    {props.textType ? (
      <Typography className={classes.text} color="textSecondary" component="span" variant="caption">
        {props.data.title}
      </Typography>
    ) : (
      <Link href={`/${props.type}/${props.data.id}?page=1`}>
        <span className={classes.link}>{props.data.name}</span>
      </Link>
    )}
  </Root>
)
